import React, { useState, useEffect } from "react";
// Import the JSON data files
import data1 from "../components/GameData.json";
import data2 from "../components/QultricData.json";

const QGDataTable = () => {
  const [mergedData, setMergedData] = useState([]);

  useEffect(() => {
    // Merge the JSON data by 'participant_id'
    const merged = mergeByParticipantId(data1, data2);

    setMergedData(merged);
  }, []);

  // Function to merge arrays by 'participant_id'
  const mergeByParticipantId = (data1, data2) => {
    const map = {};

    // Add all entries from data1 to the map by 'participant_id'
    data1.forEach((item) => {
      map[item.participant_id] = { ...item };
    });

    // Merge entries from data2 into the map
    data2.forEach((item) => {
      if (map[item.participant_id]) {
        map[item.participant_id] = { ...map[item.participant_id], ...item };
      } else {
        map[item.participant_id] = { ...item };
      }
    });
    console.log(map);
    // Convert the map back to an array
    return Object.values(map);
  };

  return (
    <div>
      <h1>Merged Participant Data</h1>
      <table className="overall_data_style_table">
        <thead>
          <tr>
            <th>Participant ID</th>
            <th className="date_th">Date</th>
            <th>User IP</th>
            <th>Survey ID</th>
            <th>Language</th>
            <th class="question_th">
              America would be better off with a strong President who did not
              have to bother with the Congress.
            </th>
            <th class="question_th">
              The courts should not stand in the way of a President who is
              acting on behalf of the country.
            </th>
            <th class="question_th">
              Because of all the fake news and biased reporting, the President
              needs to control the press to protect the people.
            </th>
            <th class="question_th">
              Sometimes a good leader must violate bad laws in order to better
              serve the interests of the people.
            </th>
            <th class="question_th">
              Our political system is not working! We need new institutions and
              laws that give our leaders the power to make the changes our
              country needs.
            </th>
            <th class="question_th">
              When we have a strong, good leader who understands what the people
              want, it is important to support the leader’s decisions even if
              you sometimes don’t agree.
            </th>
            <th class="question_th">
              When making laws or policies, the will of the majority of
              Americans is more important than the rights of a minority.
            </th>
            <th class="question_th">
              We worry too much about everyone's 'rights.' It is often necessary
              to set aside some legal rights to do what is best for the country.
            </th>
            <th class="question_th">
              Leaders who understand what America needs are just wasting their
              time trying to convince people who see things differently.
            </th>
            <th class="question_th">
              It is important for politicians to debate political issues even
              when it does not lead to agreement.
            </th>
            <th class="question_th">
              When people disagree about important political issues, talking to
              one another will not accomplish anything.
            </th>
            <th class="question_th">
              In the most important political debates, it is clear that one side
              is morally right and the other side is not.
            </th>
            <th class="question_th">
              In politics, tolerance of different moral and political views is
              really just selling out one’s own principles.
            </th>
            <th class="question_th">
              The 2024 Presidential election will be a battle between people who
              know what is good and right for America and those people who are
              deeply wrong.
            </th>
            <th class="question_th">
              The outcome of the 2024 Presidential election will be very
              important for America's future. If it becomes necessary, the use
              of violence is justified to to make sure the best candidate wins.
            </th>
            <th class="question_th">
              Below is a list of American politicians. How similar or different
              are their values to your values? - Donald Trump
            </th>
            <th class="question_th">
              Below is a list of American politicians. How similar or different
              are their values to your values? - Kamala Harris
            </th>
            <th class="question_th">
              Who are you going to vote for President? (Of if you voted already,
              who did you vote for?)
            </th>
            <th class="question_th">
              Although we are different than one another in some ways, most
              Americans share the same basic values.
            </th>
            <th class="question_th">
              Wall Street rich people have very different values than most
              Americans
            </th>
            <th class="question_th">
              Wall Street rich people are just interested in themselves, not the
              American people.
            </th>
            <th class="question_th">
              The Ivy League educated cultural elite have very different values
              than most Americans.
            </th>
            <th class="question_th">
              The Ivy League educated cultural elite are just interested in
              themselves, not the American people.
            </th>
            <th class="question_th">
              Jews have too much political power. This is a problem because they
              tend to put their own interests ahead of the interests of the
              American people.
            </th>
            <th class="question_th">
              In general, a country is better off when all its citizens share a
              common cultural or ethnic background
            </th>
            <th class="question_th">
              A country if better off when all its citizens have the same
              political opinions.
            </th>
            <th class="question_th">
              A country is better off when all its citizens share the same
              religion.
            </th>
            <th class="question_th">
              A country is better off when all its citizens are of the same
              race.
            </th>
            <th class="question_th">
              A good citizen should embrace the values and beliefs held by most
              Americans.
            </th>
            <th class="question_th">
              Some immigration is okay, but now we are letting too many
              immigrants into the US.
            </th>
            <th class="question_th">
              It’s really a matter of some people not trying hard enough; if
              black people would only try harder they could be just as well off
              as white people.
            </th>
            <th class="question_th">
              White males have excluded and exploited minorities for too long.
              They should be held accountable for the harm they have caused
            </th>
            <th class="question_th">
              The rich have taken advantage of everyone else. Their wealth and
              power should be taken away.
            </th>
            <th class="question_th">
              Zach is taller than Matt and Richard is shorter than Zach. Which
              of the following statements would be most accurate?
            </th>
            <th class="question_th">
              If the day after tomorrow is two days before Thursday, then what
              day is it today?
            </th>
            <th class="question_th">
              In the following series of letters, what letter comes next? K N P
              S U _
            </th>
            <th class="question_th">
              In the following series of letters, what letter comes next? I J L
              O S _
            </th>
            <th class="question_th">
              To complete the matrix above, which box should be added?
            </th>
            <th class="question_th">
              To correctly complete the matrix above, which box should be added?
            </th>
            <th class="question_th">
              The right-wing leaders of the Republican Party only care about
              gaining power, not about the American people.
            </th>
            <th class="question_th">
              The leaders of the Republican Party are immoral and a danger to
              America.
            </th>
            <th class="question_th">
              The left-wing leaders of the Democratic Party only care about
              gaining power, not about the American people
            </th>
            <th class="question_th">
              The leaders of the Democratic Party are immoral and a danger to
              America.
            </th>
            <th class="question_th">
              Fox News and other right-wing conservative media should be stopped
              from spreading hateful opinions and fake news.
            </th>
            <th class="question_th">
              CNN and other left-wing liberal news outlets should be stopped
              from spreading hateful opinions and fake news.
            </th>
            <th class="question_th">
              It's more important to protect America's cultural values than to
              allow free speech for left-wing liberals
            </th>
            <th class="question_th">
              Reducing inequality in America is more important than protecting
              the property rights of the very rich.
            </th>
            <th class="question_th">What is your age?</th>
            <th class="question_th">How much schooling have you had?</th>
            <th class="question_th">
              What was your total household income before taxes during the past
              12 months?
            </th>
            <th class="question_th">What is your gender?</th>
            <th class="question_th">
              How important is your gender to your sense of who you are?
            </th>
            <th class="question_th">What is your race?</th>
            <th class="question_th">
              How important is your race to your sense of who you are?
            </th>
            <th class="question_th">
              How would you describe your political ideology?
            </th>
            <th class="question_th">
              How important is your political ideology to your sense of who you
              are?
            </th>
            <th class="question_th">
              Which political party do you identify with most?
            </th>
            <th class="question_th">
              How important is your political party to your sense of who you
              are?
            </th>
            <th class="question_th">How religious are you?</th>
            <th class="question_th">
              How important is your religion to your sense of who you are?
            </th>
            <th>Fail Attempts</th>
            <th>Combination First Phase</th>
            <th>Combination Second Phase</th>
            <th>
              Based on what you saw, what does the liquid in Glass 1 do alone or
              interaction with the other liquids?*
            </th>
            <th>
              Based on what you saw, what does the liquid in Glass 2 do alone or
              interaction with the other liquids?*
            </th>
            <th>
              Based on what you saw, what does the liquid in Glass 3 do alone or
              interaction with the other liquids?*
            </th>
            <th>
              Based on what you saw, what does the liquid in Glass 4 do alone or
              interaction with the other liquids?*
            </th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(mergedData).map(([key, item], index) => (
            <tr key={index}>
              <td>{item.participant_id || "N/A"}</td>
              <td>
                {item.EndDate
                  ? new Date(item.EndDate).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })
                  : "N/A"}
              </td>
              <td>{item.IPAddress || "N/A"}</td>
              <td>{item.SV_id || "N/A"}</td>
              <td>{item.UserLanguage || "N/A"}</td>
              <td>
                {item.Q1 === 1
                  ? "Strongly agree"
                  : item.Q1 === 2
                  ? "Agree"
                  : item.Q1 === 3
                  ? "Somewhat agree"
                  : item.Q1 === 4
                  ? "Neither agree nor disagree"
                  : item.Q1 === 5
                  ? "Somewhat disagree"
                  : item.Q1 === 6
                  ? "Disagree"
                  : item.Q1 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q2 === 1
                  ? "Strongly agree"
                  : item.Q2 === 2
                  ? "Agree"
                  : item.Q2 === 3
                  ? "Somewhat agree"
                  : item.Q2 === 4
                  ? "Neither agree nor disagree"
                  : item.Q2 === 5
                  ? "Somewhat disagree"
                  : item.Q2 === 6
                  ? "Disagree"
                  : item.Q2 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q3 === 1
                  ? "Strongly agree"
                  : item.Q3 === 2
                  ? "Agree"
                  : item.Q3 === 3
                  ? "Somewhat agree"
                  : item.Q3 === 4
                  ? "Neither agree nor disagree"
                  : item.Q3 === 5
                  ? "Somewhat disagree"
                  : item.Q3 === 6
                  ? "Disagree"
                  : item.Q3 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q4 === 1
                  ? "Strongly agree"
                  : item.Q4 === 2
                  ? "Agree"
                  : item.Q4 === 3
                  ? "Somewhat agree"
                  : item.Q4 === 4
                  ? "Neither agree nor disagree"
                  : item.Q4 === 5
                  ? "Somewhat disagree"
                  : item.Q4 === 6
                  ? "Disagree"
                  : item.Q4 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q5 === 1
                  ? "Strongly agree"
                  : item.Q5 === 2
                  ? "Agree"
                  : item.Q5 === 3
                  ? "Somewhat agree"
                  : item.Q5 === 4
                  ? "Neither agree nor disagree"
                  : item.Q5 === 5
                  ? "Somewhat disagree"
                  : item.Q5 === 6
                  ? "Disagree"
                  : item.Q5 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q6 === 1
                  ? "Strongly agree"
                  : item.Q6 === 2
                  ? "Agree"
                  : item.Q6 === 3
                  ? "Somewhat agree"
                  : item.Q6 === 4
                  ? "Neither agree nor disagree"
                  : item.Q6 === 5
                  ? "Somewhat disagree"
                  : item.Q6 === 6
                  ? "Disagree"
                  : item.Q6 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q7 === 1
                  ? "Strongly agree"
                  : item.Q7 === 2
                  ? "Agree"
                  : item.Q7 === 3
                  ? "Somewhat agree"
                  : item.Q7 === 4
                  ? "Neither agree nor disagree"
                  : item.Q7 === 5
                  ? "Somewhat disagree"
                  : item.Q7 === 6
                  ? "Disagree"
                  : item.Q7 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q8 === 1
                  ? "Strongly agree"
                  : item.Q8 === 2
                  ? "Agree"
                  : item.Q8 === 3
                  ? "Somewhat agree"
                  : item.Q8 === 4
                  ? "Neither agree nor disagree"
                  : item.Q8 === 5
                  ? "Somewhat disagree"
                  : item.Q8 === 6
                  ? "Disagree"
                  : item.Q8 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q9 === 1
                  ? "Strongly agree"
                  : item.Q9 === 2
                  ? "Agree"
                  : item.Q9 === 3
                  ? "Somewhat agree"
                  : item.Q9 === 4
                  ? "Neither agree nor disagree"
                  : item.Q9 === 5
                  ? "Somewhat disagree"
                  : item.Q9 === 6
                  ? "Disagree"
                  : item.Q9 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q10 === 1
                  ? "Strongly agree"
                  : item.Q10 === 2
                  ? "Agree"
                  : item.Q10 === 3
                  ? "Somewhat agree"
                  : item.Q10 === 4
                  ? "Neither agree nor disagree"
                  : item.Q10 === 5
                  ? "Somewhat disagree"
                  : item.Q10 === 6
                  ? "Disagree"
                  : item.Q10 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q11 === 1
                  ? "Strongly agree"
                  : item.Q11 === 2
                  ? "Agree"
                  : item.Q11 === 3
                  ? "Somewhat agree"
                  : item.Q11 === 4
                  ? "Neither agree nor disagree"
                  : item.Q11 === 5
                  ? "Somewhat disagree"
                  : item.Q11 === 6
                  ? "Disagree"
                  : item.Q11 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q12 === 1
                  ? "Strongly agree"
                  : item.Q12 === 2
                  ? "Agree"
                  : item.Q12 === 3
                  ? "Somewhat agree"
                  : item.Q12 === 4
                  ? "Neither agree nor disagree"
                  : item.Q12 === 5
                  ? "Somewhat disagree"
                  : item.Q12 === 6
                  ? "Disagree"
                  : item.Q12 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q13 === 1
                  ? "Strongly agree"
                  : item.Q13 === 2
                  ? "Agree"
                  : item.Q13 === 3
                  ? "Somewhat agree"
                  : item.Q13 === 4
                  ? "Neither agree nor disagree"
                  : item.Q13 === 5
                  ? "Somewhat disagree"
                  : item.Q13 === 6
                  ? "Disagree"
                  : item.Q13 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q14 === 1
                  ? "Strongly agree"
                  : item.Q14 === 2
                  ? "Agree"
                  : item.Q14 === 3
                  ? "Somewhat agree"
                  : item.Q14 === 4
                  ? "Neither agree nor disagree"
                  : item.Q14 === 5
                  ? "Somewhat disagree"
                  : item.Q14 === 6
                  ? "Disagree"
                  : item.Q14 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q15 === 1
                  ? "Strongly agree"
                  : item.Q15 === 2
                  ? "Agree"
                  : item.Q15 === 3
                  ? "Somewhat agree"
                  : item.Q15 === 4
                  ? "Neither agree nor disagree"
                  : item.Q15 === 5
                  ? "Somewhat disagree"
                  : item.Q15 === 6
                  ? "Disagree"
                  : item.Q15 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q16 === 1
                  ? "Very Different"
                  : item.Q16 === 2
                  ? "Different"
                  : item.Q16 === 3
                  ? "Similar"
                  : item.Q16 === 4
                  ? "Very Similar"
                  : "N/A"}
              </td>
              <td>
                {item.Q17 === 1
                  ? "Very Different"
                  : item.Q17 === 2
                  ? "Different"
                  : item.Q17 === 3
                  ? "Similar"
                  : item.Q17 === 4
                  ? "Very Similar"
                  : "N/A"}
              </td>
              <td>
                {item.Q18 === 1
                  ? "Kamala Harris - Democratic Party"
                  : item.Q18 === 2
                  ? "Donald Trump - Republican Party"
                  : item.Q18 === 3
                  ? "Jill Stein - Green Party"
                  : item.Q18 === 4
                  ? "I am not going to vote for anyone"
                  : "N/A"}
              </td>
              <td>
                {item.Q19 === 1
                  ? "Strongly agree"
                  : item.Q19 === 2
                  ? "Agree"
                  : item.Q19 === 3
                  ? "Somewhat agree"
                  : item.Q19 === 4
                  ? "Neither agree nor disagree"
                  : item.Q19 === 5
                  ? "Somewhat disagree"
                  : item.Q19 === 6
                  ? "Disagree"
                  : item.Q19 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q20 === 1
                  ? "Strongly agree"
                  : item.Q20 === 2
                  ? "Agree"
                  : item.Q20 === 3
                  ? "Somewhat agree"
                  : item.Q20 === 4
                  ? "Neither agree nor disagree"
                  : item.Q20 === 5
                  ? "Somewhat disagree"
                  : item.Q20 === 6
                  ? "Disagree"
                  : item.Q20 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q21 === 1
                  ? "Strongly agree"
                  : item.Q21 === 2
                  ? "Agree"
                  : item.Q21 === 3
                  ? "Somewhat agree"
                  : item.Q21 === 4
                  ? "Neither agree nor disagree"
                  : item.Q21 === 5
                  ? "Somewhat disagree"
                  : item.Q21 === 6
                  ? "Disagree"
                  : item.Q21 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q22 === 1
                  ? "Strongly agree"
                  : item.Q22 === 2
                  ? "Agree"
                  : item.Q22 === 3
                  ? "Somewhat agree"
                  : item.Q22 === 4
                  ? "Neither agree nor disagree"
                  : item.Q22 === 5
                  ? "Somewhat disagree"
                  : item.Q22 === 6
                  ? "Disagree"
                  : item.Q22 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q23 === 1
                  ? "Strongly agree"
                  : item.Q23 === 2
                  ? "Agree"
                  : item.Q23 === 3
                  ? "Somewhat agree"
                  : item.Q23 === 4
                  ? "Neither agree nor disagree"
                  : item.Q23 === 5
                  ? "Somewhat disagree"
                  : item.Q23 === 6
                  ? "Disagree"
                  : item.Q23 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q24 === 1
                  ? "Strongly agree"
                  : item.Q24 === 2
                  ? "Agree"
                  : item.Q24 === 3
                  ? "Somewhat agree"
                  : item.Q24 === 4
                  ? "Neither agree nor disagree"
                  : item.Q24 === 5
                  ? "Somewhat disagree"
                  : item.Q24 === 6
                  ? "Disagree"
                  : item.Q24 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q25 === 1
                  ? "Strongly agree"
                  : item.Q25 === 2
                  ? "Agree"
                  : item.Q25 === 3
                  ? "Somewhat agree"
                  : item.Q25 === 4
                  ? "Neither agree nor disagree"
                  : item.Q25 === 5
                  ? "Somewhat disagree"
                  : item.Q25 === 6
                  ? "Disagree"
                  : item.Q25 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q26 === 1
                  ? "Strongly agree"
                  : item.Q26 === 2
                  ? "Agree"
                  : item.Q26 === 3
                  ? "Somewhat agree"
                  : item.Q26 === 4
                  ? "Neither agree nor disagree"
                  : item.Q26 === 5
                  ? "Somewhat disagree"
                  : item.Q26 === 6
                  ? "Disagree"
                  : item.Q26 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q27 === 1
                  ? "Strongly agree"
                  : item.Q27 === 2
                  ? "Agree"
                  : item.Q27 === 3
                  ? "Somewhat agree"
                  : item.Q27 === 4
                  ? "Neither agree nor disagree"
                  : item.Q27 === 5
                  ? "Somewhat disagree"
                  : item.Q27 === 6
                  ? "Disagree"
                  : item.Q27 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q28 === 1
                  ? "Strongly agree"
                  : item.Q28 === 2
                  ? "Agree"
                  : item.Q28 === 3
                  ? "Somewhat agree"
                  : item.Q28 === 4
                  ? "Neither agree nor disagree"
                  : item.Q28 === 5
                  ? "Somewhat disagree"
                  : item.Q28 === 6
                  ? "Disagree"
                  : item.Q28 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q29 === 1
                  ? "Strongly agree"
                  : item.Q29 === 2
                  ? "Agree"
                  : item.Q29 === 3
                  ? "Somewhat agree"
                  : item.Q29 === 4
                  ? "Neither agree nor disagree"
                  : item.Q29 === 5
                  ? "Somewhat disagree"
                  : item.Q29 === 6
                  ? "Disagree"
                  : item.Q29 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q30 === 1
                  ? "Strongly agree"
                  : item.Q30 === 2
                  ? "Agree"
                  : item.Q30 === 3
                  ? "Somewhat agree"
                  : item.Q30 === 4
                  ? "Neither agree nor disagree"
                  : item.Q30 === 5
                  ? "Somewhat disagree"
                  : item.Q30 === 6
                  ? "Disagree"
                  : item.Q30 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q31 === 1
                  ? "Strongly agree"
                  : item.Q31 === 2
                  ? "Agree"
                  : item.Q31 === 3
                  ? "Somewhat agree"
                  : item.Q31 === 4
                  ? "Neither agree nor disagree"
                  : item.Q31 === 5
                  ? "Somewhat disagree"
                  : item.Q31 === 6
                  ? "Disagree"
                  : item.Q31 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q32 === 1
                  ? "Strongly agree"
                  : item.Q32 === 2
                  ? "Agree"
                  : item.Q32 === 3
                  ? "Somewhat agree"
                  : item.Q32 === 4
                  ? "Neither agree nor disagree"
                  : item.Q32 === 5
                  ? "Somewhat disagree"
                  : item.Q32 === 6
                  ? "Disagree"
                  : item.Q32 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q33 === 1
                  ? "Strongly agree"
                  : item.Q33 === 2
                  ? "Agree"
                  : item.Q33 === 3
                  ? "Somewhat agree"
                  : item.Q33 === 4
                  ? "Neither agree nor disagree"
                  : item.Q33 === 5
                  ? "Somewhat disagree"
                  : item.Q33 === 6
                  ? "Disagree"
                  : item.Q33 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q34 === 1
                  ? "Richard is taller than Matt"
                  : item.Q34 === 2
                  ? "Richard is shorter than Matt"
                  : item.Q34 === 3
                  ? "Richard is as tall as Matt."
                  : item.Q34 === 4
                  ? "It is impossible to tell"
                  : "N/A"}
              </td>
              <td>
                {item.Q35 === 1
                  ? "Friday"
                  : item.Q35 === 2
                  ? "Monday"
                  : item.Q35 === 3
                  ? "Wednesday"
                  : item.Q35 === 4
                  ? "Saturday"
                  : item.Q35 === 5
                  ? "Tuesday"
                  : item.Q35 === 6
                  ? "Sunday"
                  : "N/A"}
              </td>
              <td>
                {item.Q36 === 1
                  ? "S"
                  : item.Q36 === 2
                  ? "T"
                  : item.Q36 === 3
                  ? "U"
                  : item.Q36 === 4
                  ? "V"
                  : item.Q36 === 5
                  ? "W"
                  : item.Q36 === 6
                  ? "X"
                  : "N/A"}
              </td>
              <td>
                {item.Q37 === 1
                  ? "T"
                  : item.Q37 === 2
                  ? "U"
                  : item.Q37 === 3
                  ? "V"
                  : item.Q37 === 4
                  ? "X"
                  : item.Q37 === 5
                  ? "Y"
                  : item.Q37 === 6
                  ? "Z"
                  : "N/A"}
              </td>
              <td>
                {item.Q38 === 1
                  ? "A"
                  : item.Q38 === 2
                  ? "B"
                  : item.Q38 === 3
                  ? "C"
                  : item.Q38 === 4
                  ? "D"
                  : item.Q38 === 5
                  ? "E"
                  : item.Q38 === 6
                  ? "F"
                  : "N/A"}
              </td>
              <td>
                {item.Q39 === 1
                  ? "A"
                  : item.Q39 === 2
                  ? "B"
                  : item.Q39 === 3
                  ? "C"
                  : item.Q39 === 4
                  ? "D"
                  : item.Q39 === 5
                  ? "E"
                  : item.Q39 === 6
                  ? "F"
                  : "N/A"}
              </td>
              <td>
                {item.Q40 === 1
                  ? "Strongly agree"
                  : item.Q40 === 2
                  ? "Agree"
                  : item.Q40 === 3
                  ? "Somewhat agree"
                  : item.Q40 === 4
                  ? "Neither agree nor disagree"
                  : item.Q40 === 5
                  ? "Somewhat disagree"
                  : item.Q40 === 6
                  ? "Disagree"
                  : item.Q40 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q41 === 1
                  ? "Strongly agree"
                  : item.Q41 === 2
                  ? "Agree"
                  : item.Q41 === 3
                  ? "Somewhat agree"
                  : item.Q41 === 4
                  ? "Neither agree nor disagree"
                  : item.Q41 === 5
                  ? "Somewhat disagree"
                  : item.Q41 === 6
                  ? "Disagree"
                  : item.Q41 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q42 === 1
                  ? "Strongly agree"
                  : item.Q42 === 2
                  ? "Agree"
                  : item.Q42 === 3
                  ? "Somewhat agree"
                  : item.Q42 === 4
                  ? "Neither agree nor disagree"
                  : item.Q42 === 5
                  ? "Somewhat disagree"
                  : item.Q42 === 6
                  ? "Disagree"
                  : item.Q42 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q43 === 1
                  ? "Strongly agree"
                  : item.Q43 === 2
                  ? "Agree"
                  : item.Q43 === 3
                  ? "Somewhat agree"
                  : item.Q43 === 4
                  ? "Neither agree nor disagree"
                  : item.Q43 === 5
                  ? "Somewhat disagree"
                  : item.Q43 === 6
                  ? "Disagree"
                  : item.Q43 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q44 === 1
                  ? "Strongly agree"
                  : item.Q44 === 2
                  ? "Agree"
                  : item.Q44 === 3
                  ? "Somewhat agree"
                  : item.Q44 === 4
                  ? "Neither agree nor disagree"
                  : item.Q44 === 5
                  ? "Somewhat disagree"
                  : item.Q44 === 6
                  ? "Disagree"
                  : item.Q44 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q45 === 1
                  ? "Strongly agree"
                  : item.Q45 === 2
                  ? "Agree"
                  : item.Q45 === 3
                  ? "Somewhat agree"
                  : item.Q45 === 4
                  ? "Neither agree nor disagree"
                  : item.Q45 === 5
                  ? "Somewhat disagree"
                  : item.Q45 === 6
                  ? "Disagree"
                  : item.Q45 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q46 === 1
                  ? "Strongly agree"
                  : item.Q46 === 2
                  ? "Agree"
                  : item.Q46 === 3
                  ? "Somewhat agree"
                  : item.Q46 === 4
                  ? "Neither agree nor disagree"
                  : item.Q46 === 5
                  ? "Somewhat disagree"
                  : item.Q46 === 6
                  ? "Disagree"
                  : item.Q46 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q47 === 1
                  ? "Strongly agree"
                  : item.Q47 === 2
                  ? "Agree"
                  : item.Q47 === 3
                  ? "Somewhat agree"
                  : item.Q47 === 4
                  ? "Neither agree nor disagree"
                  : item.Q47 === 5
                  ? "Somewhat disagree"
                  : item.Q47 === 6
                  ? "Disagree"
                  : item.Q47 === 7
                  ? "Strongly disagree"
                  : "N/A"}
              </td>
              <td>
                {item.Q48 === 1
                  ? "18 - 28"
                  : item.Q48 === 2
                  ? "29 - 38"
                  : item.Q48 === 3
                  ? "39 - 48"
                  : item.Q48 === 4
                  ? "49 - 58"
                  : item.Q48 === 5
                  ? "59 - 68"
                  : item.Q48 === 6
                  ? "69 or older"
                  : "N/A"}
              </td>
              <td>
                {item.Q49 === 1
                  ? "Some high school"
                  : item.Q49 === 2
                  ? "High school graduate"
                  : item.Q49 === 3
                  ? "Some college"
                  : item.Q49 === 4
                  ? "Graduated 4 year college"
                  : item.Q49 === 5
                  ? "Postgraduate degree"
                  : "N/A"}
              </td>
              <td>
                {item.Q50 === 1
                  ? "Less than $25,000"
                  : item.Q50 === 2
                  ? "$25,000-$49,999"
                  : item.Q50 === 3
                  ? "$50,000-$74,999"
                  : item.Q50 === 4
                  ? "$75,000-$99,999"
                  : item.Q50 === 5
                  ? "$100,000-$149,999"
                  : item.Q50 === 6
                  ? "$150,000 or more"
                  : item.Q50 === 7
                  ? "Prefer not to say"
                  : "N/A"}
              </td>
              <td>
                {item.Q51 === 1
                  ? "Female"
                  : item.Q51 === 2
                  ? "Male"
                  : item.Q51 === 3
                  ? "Other"
                  : "N/A"}
              </td>
              <td>
                {item.Q52 === 1
                  ? "Very Important"
                  : item.Q52 === 2
                  ? "Important"
                  : item.Q52 === 3
                  ? "Somewhat Important"
                  : item.Q52 === 4
                  ? "Not Important"
                  : item.Q52 === 5
                  ? "Not Important At All"
                  : "N/A"}
              </td>
              <td>
                {item.Q53 === 1
                  ? "African American"
                  : item.Q53 === 2
                  ? "Caucasian (White)"
                  : item.Q53 === 3
                  ? "East Asian"
                  : item.Q53 === 4
                  ? "Latino"
                  : item.Q53 === 5
                  ? "South Asian"
                  : item.Q53 === 6
                  ? "Mixed Race"
                  : item.Q53 === 7
                  ? "Other"
                  : "N/A"}
              </td>
              <td>
                {item.Q54 === 1
                  ? "Very Important"
                  : item.Q54 === 2
                  ? "Important"
                  : item.Q54 === 3
                  ? "Somewhat Important"
                  : item.Q54 === 4
                  ? "Not Important"
                  : item.Q54 === 5
                  ? "Not Important At All"
                  : "N/A"}
              </td>
              <td>
                {item.Q55 === 1
                  ? "very liberal"
                  : item.Q55 === 2
                  ? "liberal"
                  : item.Q55 === 3
                  ? "somewhat liberal"
                  : item.Q55 === 4
                  ? "not sure"
                  : item.Q55 === 5
                  ? "somewhat conservative"
                  : item.Q55 === 6
                  ? "conservative"
                  : item.Q55 === 7
                  ? "very conservative"
                  : "N/A"}
              </td>
              <td>
                {item.Q56 === 1
                  ? "Very Important"
                  : item.Q56 === 2
                  ? "Important"
                  : item.Q56 === 3
                  ? "Somewhat Important"
                  : item.Q56 === 4
                  ? "Not Important"
                  : item.Q56 === 5
                  ? "Not Important At All"
                  : "N/A"}
              </td>
              <td>
                {item.Q57 === 1
                  ? "Strongly Republican"
                  : item.Q57 === 2
                  ? "Republican"
                  : item.Q57 === 3
                  ? "Independent, Leaning Republican"
                  : item.Q57 === 4
                  ? "Independent"
                  : item.Q57 === 5
                  ? "Independent, Leaning Democrat"
                  : item.Q57 === 6
                  ? "Democrat"
                  : item.Q57 === 7
                  ? "Strongly Democrat"
                  : "N/A"}
              </td>
              <td>
                {item.Q58 === 1
                  ? "Very Important"
                  : item.Q58 === 2
                  ? "Important"
                  : item.Q58 === 3
                  ? "Somewhat Important"
                  : item.Q58 === 4
                  ? "Not Important"
                  : item.Q58 === 5
                  ? "Not Important At All"
                  : "N/A"}
              </td>
              <td>
                {item.Q59 === 1
                  ? "Very religious"
                  : item.Q59 === 2
                  ? "Religious"
                  : item.Q59 === 3
                  ? "Somewhat religious"
                  : item.Q59 === 4
                  ? "Not at all religious"
                  : "N/A"}
              </td>
              <td>
                {item.Q60 === 1
                  ? "Very Important"
                  : item.Q60 === 2
                  ? "Important"
                  : item.Q60 === 3
                  ? "Somewhat Important"
                  : item.Q60 === 4
                  ? "Not Important"
                  : item.Q60 === 5
                  ? "Not Important At All"
                  : "N/A"}
              </td>
              <td>{item.attemptsgame?.failAttempts || "N/A"}</td>
              <td>
                <div className="combination__phaseF_box">
                  {item.flaskCombinationsPhaseF
                    ? item.flaskCombinationsPhaseF.map((combination, index) => (
                        <span key={index}>
                          <em>[G{combination.join(", G")}]</em>
                        </span>
                      ))
                    : "N/A"}
                </div>
              </td>
              <td>
                <div className="combination__phaseF_box">
                  {item.flaskCombinationsPhaseT
                    ? item.flaskCombinationsPhaseT.map((combination, index) => (
                        <span key={index}>
                          <em>[G{combination.join(", G")}]</em>
                        </span>
                      ))
                    : "N/A"}
                </div>
              </td>
              <td>{item.answergame?.glass1 || "N/A"}</td>
              <td>{item.answergame?.glass2 || "N/A"}</td>
              <td>{item.answergame?.glass3 || "N/A"}</td>
              <td>{item.answergame?.glass4 || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default QGDataTable;
